import React from 'react'
import './paginationLoader.sass'

const PaginationLoader = () => {
    return <div className={'paginationLoader'}></div>
}

export default PaginationLoader
